export default __webpack_public_path__ + "static/media/ds01.45795cae.jpg";